// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDBNzNJcbWUx_LodJZmG0CcXNIafqtlizk",
    authDomain: "vpr-interviews.firebaseapp.com",
    projectId: "vpr-interviews",
    storageBucket: "vpr-interviews.firebasestorage.app",
    messagingSenderId: "66439790312",
    appId: "1:66439790312:web:53362897817ab22fcad35d"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
const auth = getAuth(app);

export { auth, onAuthStateChanged, signOut };